const projectList = {
  'HTML, CSS e JS': [
    {
      name: 'Lessons Learned',
      repo: 'https://github.com/IagoPFerreira/lessons-learned',
      image: 'https://github.com/IagoPFerreira/lessons-learned/raw/main/images/lessons-learned.png',
      alt: 'Demonstrando o inicio do projeto lessons learned, com um cabeçalho com o nome do projeto e links, uma foto de perfil e 2 tabelas com os conhecimentos de Iago',
      deploy: 'https://iagopferreira.github.io/lessons-learned/',
      description: 'Esta é uma aplicação simulando um currículo ou portfolio, desenvolvido usando somente HTML e CSS.',
    },
    {
      name: 'Playground Functions',
      repo: 'https://github.com/IagoPFerreira/playground-functions',
      image: 'https://github.com/IagoPFerreira/playground-functions/raw/main/playground-functions.png',
      alt: 'Demonstrando a execução de uma função do projeto playground-functions',
      description: 'Esta é uma aplicação desenvolvida puramente em JavaScript e nela existem diversas funções, como funções para cálculo de área, dividir sentenças, dentre outras.',
    },
    {
      name: 'Pixel Art',
      repo: 'https://github.com/IagoPFerreira/pixels-art',
      image: 'https://github.com/IagoPFerreira/pixels-art/raw/main/pixels-art.png',
      alt: 'Demonstrando o inicio do projeto pixels art, com uma paleta de cores para escolher, 2 botões e e uma tabela para ser pintada',
      deploy: 'https://iagopferreira.github.io/pixels-art/',
      description: 'Esta é uma aplicação para desenhos pixelados, desenvolvido com HTML, CSS e JavaScript.',
    },
    {
      name: 'To Do List',
      repo: 'https://github.com/IagoPFerreira/to-do-list',
      image: 'https://github.com/IagoPFerreira/IagoPFerreira.github.io/raw/main/to-do-list/to-do-list.png',
      alt: 'Demonstrando o inicio do projeto to do list, com botões de interação e um campo para digitar as tarefas',
      deploy: 'https://iagopferreira.github.io/to-do-list/',
      description: 'Esta é uma aplicação para criação de uma lista de tarefas, desenvolvido com HTML, CSS e JavaScript.',
    },
    {
      name: 'Meme Generator',
      repo: 'https://github.com/IagoPFerreira/meme-generator',
      image: 'https://github.com/IagoPFerreira/meme-generator/raw/main/images/meme-generator.png',
      alt: 'Demonstrando o inicio do projeto meme generator, com 4 botões de pré-seleção de bordas para as imagens, um campo para digitar as frases dos memes, um botão para inserir imagens do computador e 4 imagens pré-definidas',
      deploy: 'https://iagopferreira.github.io/meme-generator/',
      description: 'Esta é uma aplicação de um gerador de memes, desenvolvido com HTML, CSS e JavaScript.',
    },
    {
      name: 'Shopping Cart',
      repo: 'https://github.com/IagoPFerreira/shopping-cart',
      image: 'https://github.com/IagoPFerreira/shopping-cart/raw/main/shopping-cart.png',
      alt: 'Demonstrando o inicio do projeto shopping cart, com 8 cards de computadores, com suas descrições técnicas imagens dos computadores e um botão para adiciona-los no carrinho, uma área onde é o carrinho e compras com um botão para esvaziar o carrinho, uma área onde é o carrinho com alguns itens nele e um container com o preço total da compra.',
      deploy: 'https://iagopferreira.github.io/shopping-cart/',
      description: 'Essa é uma aplicação de um carrinho de compras onde os itens para adicionar no carrinho são provenientes de uma API do Mercado Livre.',
    },
  ],
  'React.js': [
    {
      name: 'Trybetunes',
      repo: 'https://github.com/IagoPFerreira/trybetunes',
      image: 'https://github.com/IagoPFerreira/trybetunes/raw/main/src/images/preview.png',
      alt: 'Demonstrando a tela inicial do Trybetune, com um logo com uma nota musical nas cores azul e rosa, um campo de input para e-mail, e um botão de submissão do e-mail para fazer o login',
      deploy: 'https://iagopferreira.github.io/trybetunes/',
      description: 'Esta aplicação foi desenvolvida usando React. Ela é uma aplicação onde você pode fazer consulta de bandas e ouvir trechos de suas músicas.',
    },
    {
      name: 'Recipe App',
      repo: 'https://github.com/IagoPFerreira/recipes-app',
      alt: 'Demonstrando a tela inicial do Recipe App, com um campo de input para e-mail, e um botão de submissão do e-mail para fazer o login',
      image: 'https://github.com/IagoPFerreira/recipes-app/raw/main/src/images/preview.png',
      deploy: 'https://recipes-app-fe.herokuapp.com/',
      description: 'Esta aplicação foi desenvolvida usando React Hooks e Context-API. Ela é um aplicativo onde você pode fazer consulta de receitas de comidas e bebidas.',
    },
    {
      name: 'Characters Card',
      repo: 'https://github.com/IagoPFerreira/characters-card',
      alt: 'Demonstrando a tela inicial do Characters Card, com os cards dos personagens e um botão para adicionar um novo personagem',
      image: 'https://github.com/IagoPFerreira/characters-card/raw/create-characters/characters-card.png',
      deploy: 'https://IagoPFerreira.github.io/characters-card',
      description: 'Esta aplicação foi desenvolvida usando React. Ela é uma aplicação onde são exibidos cards de personagens fictícios e informações desses personagens podem ser acessadas nas suas páginas específicas.',
    },

  ],
  'Node.js': [
    {
      name: 'Cookmaster',
      repo: 'https://github.com/IagoPFerreira/cookmaster',
      image: 'https://github.com/IagoPFerreira/cookmaster/raw/main/images/preview.png',
      alt: 'Demonstrando a execução de uma requisição do projeto Cookmaster',
      description: 'Esta é uma aplicação Node e foi desenvolvida utilizando a arquitetura de camadas MSC. É uma API para busca de receitas.',
    },
    {
      name: 'Task Organizer',
      repo: 'https://github.com/IagoPFerreira/task-organizer-bk',
      image: 'https://github.com/IagoPFerreira/task-organizer-bk/raw/main/images/preview.png',
      alt: 'Demonstrando a execução de uma requisição do projeto Task Organizer',
      description: 'Esta é uma aplicação Node e foi desenvolvida utilizando a arquitetura de camadas MSC. É uma API para organização de tarefas.',
    },
  ],
  Python: [
    {
      name: 'Job Insights',
      repo: 'https://github.com/IagoPFerreira/job-insights',
      image: 'https://github.com/IagoPFerreira/job-insights/raw/main/preview.png',
      alt: 'Demonstrando a execução do código do projeto job-insights',
      description: 'Este projeto foi desenvolvido utilizando Python. Neste projeto foram implementadas análises a partir de um conjunto de dados sobre empregos.',
    },
    {
      name: 'Tech News',
      repo: 'https://github.com/IagoPFerreira/tech-news',
      image: 'https://github.com/IagoPFerreira/tech-news/raw/main/preview.png',
      alt: 'Demonstrando a execução do código do projeto tech-news',
      description: 'Este projeto foi desenvolvido utilizando Python. Através dessa aplicação, é possível fazer raspagem de dados do site TecMundo.',
    },
    {
      name: 'Inventory Report',
      repo: 'https://github.com/IagoPFerreira/inventory-report',
      image: 'https://github.com/IagoPFerreira/inventory-report/raw/main/preview.png',
      alt: 'Demonstrando a execução do código do projeto Inventory report',
      description: 'Este projeto foi desenvolvido utilizando Python. Através dessa aplicação, é possível gerar relatórios de um inventário, baseado em dados de arquivos csv, json e xml.',
    },
  ],
};

export default projectList;
